// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__27TIg","icon":"SortAdornment_icon__2erjv","up":"SortAdornment_up__2S_0x","down":"SortAdornment_down__1B3CO","active":"SortAdornment_active__3ZwJ9"};